import { React, useState, useEffect, useRef } from 'react'
import Sidebar from '../../layouts/sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-modal';
import './organisationDetails.css'
import OrganisationPolicyModal from '../modal/OrganisationPolicyModal';
import apiService from '../../../services/apiService'
import Loader from '../../layouts/loader';
import { useTranslation } from 'react-i18next';


const OrganisationDetails = () => {
  const { t } = useTranslation();
  const [courseDetails, setCourseDetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [isOpenPolicyModal, setIsOpenPolicyModal] = useState(false)
  const [icMembers, setIcMembers] = useState([""]);
  const [isPoshPolicy, setPoshPolicy] = useState([])
  const [sidebarVisible, setSidebarVisible] = useState(window.innerWidth < 991 ? false : true);
  const [orgName, setOrgName] = useState("");

  // Add ref for table container
  const tableContainerRef = useRef(null);

  const closeGeneModal = () => {
    setIsOpenPolicyModal(false)
  }

  useEffect(() => {
    const fetchICMembers = async () => {
      try {
        let orgId = JSON.parse(localStorage.getItem("orgInfo"));
        setOrgName(orgId.org_name);
        const token = apiService.getAuthToken()
        const icRes = await apiService.get(`get-ic-user-list-by-id/${orgId.org_id}`, token);
        setIcMembers(icRes?.data || []);
        const policyRes = await apiService.get(`get-posh-policy-document/${orgId.org_id}`, token);
        setPoshPolicy(policyRes?.data || []);
        console.log("policy++++", policyRes)
      } catch (error) {
        console.error("Error fetching IC List:", error);
      }
      finally {
        setLoader(false);
      }

    };
    fetchICMembers();
  }, []);


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return "-";

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const handleSidebarToggle = (visible) => {
    setSidebarVisible(visible);
  };

  // Function to scroll table left
  const scrollTableLeft = () => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollBy({
        left: -200, // Scroll 200px to the left
        behavior: 'smooth'
      });
    }
  };

  // Function to scroll table right
  const scrollTableRight = () => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollBy({
        left: 200, // Scroll 200px to the right
        behavior: 'smooth'
      });
    }
  };


  return (
    <>

      {loader ? <Loader /> : (
        <>
          <div className='page__main' style={{ minHeight: '100vh' }}>
            <div className="dashboard py-3">
              <div className="container-fluid mt-2 pb-md-3">
                <div className="row saffron-main-header mb-4 ms-2 w-100">
                  <div className="header-content-wrapper ms-0 px-1">
                    <div className="d-md-flex align-items-center">
                      <img
                        src="/images/org_policy.svg"
                        alt="Saffron Stays Logo"
                        className="company-logo d-none d-lg-block"
                        style={{
                          width: '155px',
                          height: '150px'
                        }}
                      />

                      <div className="text-md-content">
                        <h1 className="company-title fs-md-5 fs-4">
                          <span className="text-capitalize">{orgName}</span> is committed to building a Safe Workplace
                        </h1>

                        <div className="mission-statement mt-md-0 mt-3">
                          <p className="mission-text fw-regular  fs-7 fs-lg-5 d-none d-lg-block">
                            Read your organisation’s Safe Workplace (PoSH) Policy to understand your rights, responsibilities, and  <br className="d-none d-lg-block" /> the steps we take to ensure a respectful, inclusive environment for all.
                          </p>

                          <p className="mission-text fw-normal   fs-lg-5 fs-7  d-lg-none">
                            Read your organisation’s Safe Workplace (PoSH) Policy to understand your rights, responsibilities, and  <br className="d-none d-lg-block" /> the steps we take to ensure a respectful, inclusive environment for all.
                          </p>
                        </div>
                      </div>

                    </div>
                    <div className="d-flex justify-content-center d-lg-none mb-3">
                      <img
                        src="/images/org_policy.svg"
                        alt="Saffron Stays Logo"
                        className="company-logo"
                        style={{ width: '130px', height: '130px' }}
                      />
                    </div>

                    <button
                      className="policy-btn btn btn-primary"
                      onClick={() => {
                        if (Array.isArray(isPoshPolicy) && isPoshPolicy.length > 0) {
                          const supportedTypes = ['pdf', 'docx', 'doc', 'png', 'jpg', 'jpeg', 'webp'];

                          let delay = 0;
                          isPoshPolicy.forEach(fileUrl => {
                            const extension = fileUrl.split('.').pop().toLowerCase();
                            if (supportedTypes.includes(extension)) {
                              setTimeout(() => {
                                window.open(fileUrl, '_blank');
                              }, delay);
                              delay += 100;
                            } else {
                              console.warn(`Unsupported file type: ${extension}`);
                            }
                          });
                        } else {
                          setIsOpenPolicyModal(true);
                        }
                      }}
                    >

                      <h4 className="policy-text">{t('organisation_modal_policy')}</h4>
                    </button>
                  </div>
                </div>

                <div className="row shadow-custom internal-committee-container ms-2 me-0" style={{
                  background: '#ffffff',
                }}>

                  <section className="rights-section d-flex align-items-start justify-content-between ">
                    <div className="text-content">
                      <h2 className='fw-semibold fs-4 fs-lg-3'>Know your rights, know your Internal Committee.</h2>
                      <p>
                        Report any incident of sexual harassment to the IC immediately. You can also register your complaint on{" "}
                        <a href="https://shebox.wcd.gov.in/" target="_blank" rel="noopener noreferrer" >
                          <span style={{ color: '#146EF6', textDecoration: 'underline' }}>
                            www.shebox.wcd.gov.in
                          </span>
                        </a>
                      </p>
                    </div>

                    <img
                      src="/images/org-table-logo.svg"
                      alt="Saffron Stays Logo"
                      className="company-logo  d-none d-lg-block"
                    />
                  </section>
                  <hr style={{ marginLeft: '-20px', marginRight: '-20px', borderColor: '#cc', borderWidth: '1px', }}
                  />



                  <section className="ic-members">
                    <div className="ic-heading d-flex align-items-center ">
                      <>
                        <img
                          src="/images/org_ic_icon.png"
                          alt="Organisation IC"
                          className="org-ic-icon"
                        />
                        <h3 className="mt-3" style={{ width: '75%' }}>{t('organisation_details_table_heading')}</h3>
                      </>
                      <div className='d-flex align-self-end ms-auto mb-1 '>
                        <a className="scroll-arrow left text-decoration-none" onClick={scrollTableLeft} style={{ cursor: 'pointer' }}>
                          <span> <img
                            src="/images/arrow-left.svg"
                            alt="Previous"
                            width={30}
                          /></span>
                        </a>
                        <a className="scroll-arrow right text-decoration-none ms-2" onClick={scrollTableRight} style={{ cursor: 'pointer' }}>
                          <span> <img
                            src="/images/arrow-right.svg"
                            alt="Previous"
                            width={30}
                          /></span>
                        </a>
                      </div>
                    </div>
                    <div className="table-responsive" ref={tableContainerRef}>
                      <table className="ic-table">
                        <thead>
                          <tr>
                            <th>Sr.No</th>
                            <th>Full Name</th>
                            <th>Designation</th>
                            <th>Location</th>
                            <th>Email ID</th>
                            <th>Phone No.</th>
                            <th>Date of Commencement</th>
                          </tr>
                        </thead>
                        <tbody>
                          {icMembers.length > 0 ? (
                            icMembers.map((member, index) => (
                              <tr key={member.id || index}>
                                <td>{index + 1}</td>
                                <td>
                                  <div className="d-flex flex-column">
                                    <strong>{member.name || '-'}</strong>
                                    <span className="text-muted" style={{ fontSize: '13px', marginTop: '4px' }}>
                                      {member.post_of_ic_member || '-'}</span>
                                  </div>
                                </td>
                                <td>{member.ic_designation || '-'}</td>
                                <td>{member.ic_location || '-'}</td>
                                <td>{member.email || '-'}</td>
                                <td>{member.mobile || '-'}</td>
                                <td>
                                  {member.tenure_from && member.tenure_to ? (
                                    `${formatDate(member.tenure_from)}  To  ${formatDate(member.tenure_to)}`
                                  ) : (
                                    '-'
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7">
                                <div className="custom-flex-box">
                                  <img
                                    src="/images/empty_records_icon.png"
                                    alt="Empty Records"
                                    className=''
                                  />
                                  <p style={{ margin: 0, fontSize: '16px', color: '#555' }}>
                                    {t('organisation_details_empty_data')}
                                  </p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="justify-content-center d-lg-none d-flex mt-4">
                        <img
                          src="/images/org-table-logo.svg"
                          alt="Saffron Stays Logo"
                          className="company-logo  d-lg-none"
                        />
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>

          <Modal isOpen={isOpenPolicyModal}>
            <OrganisationPolicyModal isOpen={isOpenPolicyModal} onRequestClose={closeGeneModal} />
          </Modal>
        </>
      )}
    </>
  )
}

export default OrganisationDetails